<template>
  <div>
    <!-- 使用 el-tabs 的 v-model 来控制当前激活的 Tab -->
    <p style="font-size: 14px; margin-left: 10px">估值计算时间：{{ formattedTime }}</p>
    <el-tabs v-model="currentTab" tab-class="custom-tabs">
<!--      <div>-->
<!--        <button @click="openDialogtest">打开测试对话框</button>-->

<!--        &lt;!&ndash; 对话框 &ndash;&gt;-->
<!--        <el-dialog v-model="isDialogVisible" title="轮询数据" @close="closeDialogtest">-->
<!--          <div>-->
<!--            <p>当前时间：{{ currentTime }}</p>-->
<!--            <p>服务器返回的数据：{{ serverData }}</p>-->
<!--          </div>-->
<!--        </el-dialog>-->
<!--      </div>-->

<!--      <el-button type="text" @click="openDialog">点击打开 Dialog</el-button>-->
      <!--      :before-close="handleClose"-->
      <!-- 父组件 -->
      <div>
        <button @click="openDialog">打开 Dialog</button>
        <test-dialog
            :title="dialogTitle"
            :content="dialogContent"
            v-model:visible="isDialogVisible"
        />
      </div>
      <el-tab-pane label="指数基" name="fundZhiShu">
      </el-tab-pane>
      <el-tab-pane label="股票基" name="fundGuPiao">
      </el-tab-pane>

      <el-tab-pane
          label="Qdii"
          name="fundQdii"
      >
      </el-tab-pane>

      <el-tab-pane
          label="套利汇总"
          name="fundTaoli"
      >
      </el-tab-pane>

      <el-tab-pane
          label="我的收藏"
          name="fundList1"
      >
      </el-tab-pane>
    </el-tabs>

    <component :is="currentTabComponent"></component>
  </div>
</template>

<script setup>
import {computed, provide, reactive, ref} from 'vue';
import fundZhiShu from "@/components/fund/FunZhishu.vue";
import fundGuPiao from "@/components/fund/FundGuPiao.vue";
import fundTaoli from "@/components/fund/FundTaoli.vue";
import fundList1 from "@/components/fund/FundList1.vue";
import fundQdii from "@/components/fund/FundQdii.vue";
import TestDialog from "@/components/dialog/testDialog.vue";

// 定义当前标签
const currentTab = ref('fundZhiShu'); // 使用 ref 定义一个字符串类型的响应式变量

// 定义共享数据
const sharedData = reactive({
  message: 'Hello from Grandparent',
  updateMessage: (newMessage) => {
    sharedData.message = newMessage;
  },
});

// 提供数据
provide('sharedData', sharedData);

// 动态组件
const currentTabComponent = computed(() => {
  switch (currentTab.value) {
    case 'fundZhiShu':
      return fundZhiShu;
    case 'fundGuPiao':
      return fundGuPiao;
    case 'fundQdii':
      return fundQdii;
    case 'fundList1':
      return fundList1;
    case 'fundTaoli':
      return fundTaoli;
    default:
      return null;
  }
});


// 格式化时间
const formattedTime = computed(() => {
  const date = new Date(sharedData.message);
  return date.toLocaleString(); // 使用默认的本地化格式
});

// 定义数据
const isDialogVisible = ref(false); // 控制 Dialog 的显示与隐藏
const dialogTitle = ref("自定义标题"); // Dialog 的标题
const dialogContent = ref("这是自定义的内容"); // Dialog 的内容

// 打开 Dialog 的方法
const openDialog = () => {
  dialogTitle.value = new Date().toLocaleTimeString();
  isDialogVisible.value = true;
};

</script>

<style scoped>
/* 在 App.vue 中设置全局样式 */

/* 设置表格单元格的字体大小 */
.el-table td,
.el-table th {
  font-size: 12px; /* 可以根据需要调整字体大小 */
}

.header p {
  margin: 5px 0;
}


</style>